export const CARD_LABELS = {
  stageCompletion: 'Закриття етапу',
  partnership: 'Партнерство, нові люди',
  newOpportunities: 'Нові можливості',
  movementDespiteObstacles: 'Рух, попри перешкоди',
  changes: 'Зміни',
  balance: 'Баланс',
  signsOfFate: 'Знаки долі',
  pauseAndWaiting: 'Пауза, очікування',
  doubtsAndInnerConflict: 'Сумніви, внутрішній конфлікт',
  boundaries: 'Кордони',
  inspiration: 'Натхнення',
  victory: 'Перемога'
};

export const PREDICTIONS = [
  {
    cards: ['stageCompletion', 'doubtsAndInnerConflict', 'changes'],
    text:
      'Ти стоїш на порозі грандіозних змін. Попередній життєвий етап дав тобі ' +
      'безцінний досвід, але внутрішній потенціал уже переріс колишні рамки. ' +
      'Настав час відключити зовнішній шум та відпустити сумніви. Всередині ти ' +
      'вже давно знаєш правильне рішення.'
  },
  {
    cards: ['signsOfFate', 'balance', 'partnership'],
    text:
      'Твій головний магніт — це абсолютна щирість із собою та внутрішній ' +
      'професіоналізм. Саме ця енергія найбільшим часом притягує у твоє поле ' +
      'потрібних людей, точні рішення та правильні можливості. Всесвіт грає на ' +
      'твоєму боці, навіть якщо поки здається, що це не так.'
  },
  {
    cards: ['newOpportunities', 'movementDespiteObstacles', 'victory'],
    text:
      'Попереду — вихід на нову вершину та розширення кордонів. Чекай на якісний ' +
      'прорив: у твоє життя йде довгоочікувана якість, глибока взаємність та ' +
      'доленосні пропозиції, які потягнуть за собою і визнання, і фінансовий ' +
      'успіх. Дій сміливо та не озирайся.'
  },
  {
    cards: ['pauseAndWaiting', 'changes', 'signsOfFate'],
    text:
      'Настав час уповільнити біг та прислухатися до себе. Період метушні, ' +
      'сумнівів та емоційних гойдалок залишається позаду. Внутрішній туман ' +
      'розсіюється, і ти знову бачиш свій чіткий орієнтир, довірся йому.'
  },
  {
    cards: ['boundaries', 'pauseAndWaiting', 'partnership'],
    text:
      'Ти людина, яка вміє відстоювати свої межі та не зраджувати себе — це про ' +
      'самоповагу. Саме тому твої зв’язки не випадкові — ти притягуєш тих, хто ' +
      'готовий на справжнє партнерство. Для тебе починається період реальних ' +
      'взаємодій; не варто закриватися і тягнути все самостійно.'
  },
  {
    cards: ['balance', 'boundaries', 'victory'],
    text:
      'Етап життя, на якому ти зараз, принесе тобі омріяний комфорт, стабільність ' +
      'та матеріалізацію внутрішніх запитів. Всі перешкоди завершуються ' +
      'формуванням міцного фундаменту, де є повага, тепло і спокій на майбутнє. ' +
      'Тобі залишається найважливіше — дозволити собі прийняти ці блага.'
  },
  {
    cards: ['changes', 'stageCompletion', 'doubtsAndInnerConflict'],
    text:
      'Твій основний козир — твоя тонка інтуїція. Зараз у твоєму житті ' +
      'запускаються позитивні зміни, які допомагають м’яко закрити старий етап і ' +
      'звільнити місце для кращого. Навіть якщо іноді з’являються сумніви, це ' +
      'знак того, що ти переходиш на новий рівень.'
  },
  {
    cards: ['partnership', 'inspiration', 'newOpportunities'],
    text:
      'У тобі вирує енергія дії, пристрасті та творення. Твій головний козир ' +
      'зараз — це шалений особистий магнетизм і внутрішній запал. Світ готовий ' +
      'підлаштуватися під твій запит, тому не бійся заявляти про свої бажання на ' +
      'повний голос. Все йтиме прямо до твоїх рук.'
  },
  {
    cards: ['movementDespiteObstacles', 'inspiration', 'victory'],
    text:
      'Ситуація, яка тривожить, вирішується на твою користь. На тебе чекає повний ' +
      'розклад: це час взаємності, лідерства, успішних угод, планування приємних ' +
      'подорожей та виходу на новий рівень. Не сумнівайся — усе відбудеться в ' +
      'ідеальний для тебе момент.'
  },
  {
    cards: ['doubtsAndInnerConflict', 'balance', 'victory'],
    text:
      'Ти виходиш із періоду сумнівів та внутрішніх коливань у стан балансу, де ' +
      'починаєш чітко відчувати, що тобі правильно — і це твій ключ до перемоги. ' +
      'У фінансах це може дати вдале рішення або приріст доходу, у подорожах — ' +
      'поїздку, яка розширить світогляд. З радістю входь у нові повороти та в ' +
      'кохання — гармонію й відчуття впевненості у взаємності.'
  },
  {
    cards: ['signsOfFate', 'inspiration', 'balance'],
    text:
      'Доля дає тобі зараз дуже конкретні знаки — через випадкові розмови, ідеї ' +
      'або навіть «випадкові» можливості. Важливо не ігнорувати ці сигнали, бо ' +
      'саме вони ведуть тебе не просто до відчуття, а до дій. Прислухайся до ' +
      'інтуїції, який знак варто одразу реалізувати.'
  },
  {
    cards: ['movementDespiteObstacles', 'stageCompletion', 'newOpportunities'],
    text:
      'Ти рухаєшся вперед попри всі перешкоди, бо всередині тебе є сильний ' +
      'вогонь — це про характер, бажання й внутрішню пристрасть, яка не дає ' +
      'зупинитися. Всесвіт готує для тебе нові можливості. З радістю входь у нові ' +
      'повороти та дозволь приємній несподіванці застати тебе зненацька.'
  }
];

export const drawPrediction = () =>
  PREDICTIONS[Math.floor(Math.random() * PREDICTIONS.length)];
